<template>
  <div class="page background-main">
    <!-- <AppBackgroundCanvas /> -->
    <div class="page_stage_shell">
      <div class="page_stage">
        <div class="app_body">
          <div class="main_container">
            <template v-if="isDeviceSelected">
              <Root></Root>
            </template>
            <template v-if="!isDeviceSelected">
              <empty v-if="isShowEmpty" />
              <selector v-else />
            </template>
            <cdialog />
            <SwitchKeySyncDialog />
            <loading />
            <feedback />
            <setting />
            <keyboard_appearance_floating />
            <software_theme_floating />

            <app_update_notice />
            <service_update_notice />
            <Pair24g />
            <Firmware_upgrade />
            <dev_brand_switcher />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import cdialog from '@/components/cdialog/cdialog.vue'
import SwitchKeySyncDialog from '@/components/cdialog/SwitchKeySyncDialog.vue'
import keyboard_appearance_floating from '@/components/setting/keyboard_appearance_floating.vue'
import software_theme_floating from '@/components/setting/software_theme_floating.vue'
import loading from '@/components/loading/loading.vue'
import feedback from './components/feedback/feedback.vue'
import empty from './components/empty/empty.vue'
import selector from './components/selector/selector.vue'
import setting, { setBoxBool } from './components/setting/setting.vue'
import Pair24g from './components/pair_24g/pair_24g.vue'
import { DeviceManager, DeviceProtocol } from './service/device'
import { DevicePid, EEvisionDeviceList } from './define/define'

import service_update_notice from '@/components/service_update/service_update_notice.vue'
import app_update_notice from './components/app_update/app_update_notice.vue'
import { isElectron } from '@libs/utils/envUtils'
import Root from './components/main/root.vue'
import Firmware_upgrade from './components/firmware_upgrade/firmware_upgrade.vue'
import dev_brand_switcher from '@/components/dev/dev_brand_switcher.vue'
import { closeKeyboardAppearancePanel } from '@/service/keyboard_appearance'
import { closeAllAppearancePanels } from '@/service/appearance_panel_registry'

import { trackWebActivity } from '@/utils/appEffect'

const isDeviceSelected = computed(() => DeviceManager.instance.state.currentPid != DevicePid.None)
const isShowEmpty = computed(() => {
  return isElectron() && DeviceManager.instance.state.webDeviceList.concat(DeviceManager.instance.state.deviceList).length == 0
})

const allDeviceList = computed(() => DeviceManager.instance.state.webDeviceList.concat(DeviceManager.instance.state.deviceList))

watch(allDeviceList, (list, oldList) => {
  // 只在从 0 个设备变为 1 个设备时自动跳转（初次发现 / 重连）
  // 若 oldList 已有设备（如用户点击"继续授权"后列表刷新），不触发自动跳转
  if (list.length === 1 && oldList.length === 0 && DeviceManager.instance.state.currentPid === DevicePid.None) {
    const device = list[0]
    // EEvision 设备需要弹窗引导打开外部程序，不自动跳转
    if (EEvisionDeviceList.get(device.ID) != undefined) return
    const mode = DeviceManager.instance.state.webDeviceList.length > 0 ? DeviceProtocol.hid_web : DeviceProtocol.dll_exe
    DeviceManager.instance.selectCurrentDevice(device.ID, mode)
  }
})

watch(setBoxBool, (value) => {
  if (value) {
    closeAllAppearancePanels()
  }
})

watch(isDeviceSelected, (value) => {
  if (!value) {
    closeKeyboardAppearancePanel()
  }
})

// 网页驱动增加日活, 要求当前使用的语言是中文, 进行统计
trackWebActivity()

if (process.env.NODE_ENV === 'development' && typeof electronAPI !== 'undefined') {
  electronAPI.openDev()
}
</script>

<style scoped lang="less">
.page {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  font-family: var(--font-main);
}

.page_stage_shell {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  flex-shrink: 0;
  overflow: hidden;
  z-index: 1;
}

.page_stage {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  // padding: 8px;
  backface-visibility: hidden;
  // border-radius: 20px;
  // background: var(--shell-surface);
  // border: 1px solid rgba(var(--color-brand-1-rgb), 0.06);
  overflow: hidden;
}

.app_body {
  flex: 1;
  min-height: 0;
  display: flex;
  border-radius: 0;
  overflow: hidden;
}

.main_container {
  flex: 1;
  display: flex;
  position: relative;
  min-height: 0;
}

.global_appearance_entry {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 180;
  min-width: 0;
  background: var(--glass-ghost-bg);
  backdrop-filter: var(--glass-ghost-blur);
  border: 1px solid var(--glass-ghost-border);
  color: var(--shell-text-primary);

  &:hover {
    background: var(--glass-ghost-hover-bg);
    border-color: var(--glass-ghost-hover-border);
  }
}
</style>
